import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-monitoring-wrapper',
  templateUrl: './monitoring-wrapper.component.html',
  styleUrls: ['./monitoring-wrapper.component.scss'],
  standalone: false,
})
export class MonitoringWrapperComponent {}
